import React, { FC, ReactNode } from 'react';
import { IconCheckmarkCircleFill, IconCloseFill, IconTimerOutline } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import { IconButton } from '@saucelabs/ds-button';

export const Heading: FC<HeadingProps> = ({ children, onClose }) => (
  <div className="flex flex-row flex-nowrap">
    <div className="pr-2">
      <IconTimerOutline
        className="fill-current text-blue-700 h-3 w-3"
      />
    </div>
    <Typography
      className="text-high-emphasis m-0"
      disableSpacing
      variant="heading-3"
    >
      {children}
    </Typography>
    <div className="ml-auto">
      <IconButton
        data-qa="one-click-billing-close"
        icon={<IconCloseFill />}
        onPress={onClose}
        size="sm"
        variant="text"
      />
    </div>
  </div>
);

export interface HeadingProps {
  children: ReactNode;
  onClose: () => void;
}

export const List: FC<ListProps> = ({ checkList }) => (
  <ul className="my-2 list-none p-0 mx-0">
    {checkList.map((checkitem, index) => (
      <Typography
        // eslint-disable-next-line react/no-array-index-key
        key={`checklist-item-${index}`}
        className="text-high-emphasis"
        component="li"
        variant="body"
      >
        <span className="mr-1">
          <IconCheckmarkCircleFill
            className="fill-current text-green-400"
            height={14}
            width={14}
          />
        </span>
        {checkitem}
      </Typography>
    ))}
  </ul>
);

export interface ListProps {
  checkList: ReactNode[];
}

export const Actions: FC<ActionsProps> = ({ children }) => (
  <div className="flex flex-col flex-nowrap space-y-1 mt-2">
    {children}
  </div>
);

export interface ActionsProps {
  children: ReactNode;
}
